import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ExternalLink } from 'lucide-react'
import { Message } from '../../../../../utils/conversationStorage'
import styles from './CreatedPortfolioPostCard.module.scss'

const CreatedPostCard: React.FC<{ post: NonNullable<Message['createdPost']> }> = ({ post }) => {
  const navigate = useNavigate()
  const imageUrl = post.images?.[0]?.image
  const contentPreview = post.content
    ? post.content.replace(/\n/g, ' ').slice(0, 120) + (post.content.length > 120 ? '…' : '')
    : 'Post publicado'
  const userId = post.user?.id
  return (
    <div className={styles.createdPortfolioCard}>
      <div className={styles.createdPortfolioPreview}>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt=""
            className={styles.createdPortfolioImage}
          />
        ) : (
          <div className={styles.createdPortfolioPlaceholder} />
        )}
        <div className={styles.createdPortfolioInfo}>
          <span className={styles.createdPortfolioName}>Post publicado</span>
          <span className={styles.createdPortfolioPrice}>{contentPreview}</span>
        </div>
      </div>
      <div className={styles.createdPortfolioActions}>
        <button
          type="button"
          className={styles.createdPortfolioBtn}
          onClick={() => navigate('/marketplace/explorar')}
        >
          <ExternalLink size={14} />
          Ver en Explorar
        </button>
        {userId && (
          <button
            type="button"
            className={styles.createdPortfolioBtnSecondary}
            onClick={() => navigate(`/perfil/${userId}`)}
          >
            Ir a mi perfil
          </button>
        )}
      </div>
    </div>
  )
}

export default CreatedPostCard
